import React from "react";
const Budget = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.666 10.7513C12.33 11.4113 11.7713 11.9853 11.06 12.4186L11.3833 13.4853C11.4015 13.5451 11.4053 13.6082 11.3946 13.6697C11.384 13.7313 11.359 13.7894 11.3218 13.8396C11.2846 13.8897 11.2362 13.9305 11.1805 13.9586C11.1247 13.9866 11.0631 14.0013 11.0007 14.0013H9.82468C9.73813 14.0013 9.65392 13.9732 9.58468 13.9213L8.65468 13.2233H7.03002L6.10002 13.9213C6.03078 13.9732 5.94656 14.0013 5.86002 14.0013H4.68402C4.62158 14.0013 4.56001 13.9866 4.50425 13.9586C4.44848 13.9305 4.40006 13.8897 4.36287 13.8396C4.32568 13.7894 4.30074 13.7313 4.29006 13.6697C4.27937 13.6082 4.28324 13.5451 4.30135 13.4853L4.62468 12.4186C3.43135 11.6913 2.66602 10.5673 2.66602 9.30664C2.66602 7.1133 4.98335 5.33464 7.84268 5.33464C8.42202 5.33464 9.14602 5.5333 9.66602 5.66797L12.666 4.66797L12.61 7.08664L13.9993 7.66797V10.0013L12.7153 10.668"
      stroke="currentcolor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3492 9.49922C10.0442 9.49922 9.75171 9.37806 9.53605 9.16239C9.32038 8.94673 9.19922 8.65422 9.19922 8.34922C9.19922 8.04422 9.32038 7.75171 9.53605 7.53605C9.75171 7.32038 10.0442 7.19922 10.3492 7.19922C10.6542 7.19922 10.9467 7.32038 11.1624 7.53605C11.3781 7.75171 11.4992 8.04422 11.4992 8.34922C11.4992 8.65422 11.3781 8.94673 11.1624 9.16239C10.9467 9.37806 10.6542 9.49922 10.3492 9.49922Z"
      fill="currentcolor"
    />
    <path
      d="M1.33301 6.66797C1.33301 6.66797 1.33301 8.26797 2.66634 8.66797"
      stroke="currentcolor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.53333 5.16867C8.62 4.92067 8.66667 4.654 8.66667 4.37667C8.66667 3.064 7.622 2 6.33333 2C5.04467 2 4 3.064 4 4.37667C4 5.004 4.23867 5.57533 4.62933 6"
      stroke="currentcolor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

export default Budget;
